import Behavior from "../../models/Behavior";
import Conversation from "../../models/Conversation";
import Message from "../../models/Message";
import Operator from "../../models/Operator";
import { ApiClient } from "../../utils/ApiClient";

/**
 * **Webmessenger Endpoints**
 */
export default class Webmessenger {
    /** @hidden */
    protected client: ApiClient;

    /**@hidden */
    constructor() {
        this.client = new ApiClient("");
    }

    public async getConversation(_id?: string): Promise<Conversation> {
        if (_id) return await this.client.get(`/conversation/${_id}`);
        return await this.client.get("/conversation");
    }

    public async getMessages(_id: string): Promise<Message[]> {
        return await this.client.get(`/conversation/${_id}/messages`);
    }

    public async sendMessage(body: object): Promise<Message> {
        return await this.client.post("/message", body);
    }

    public async markMessageAsReceived(
        conversationId: string,
        messageId: string
    ): Promise<Message> {
        return await this.client.post(
            `/conversation/${conversationId}/received`,
            { message: messageId }
        );
    }

    public async markMessageAsRead(
        conversationId: string,
        messageId: string
    ): Promise<Message> {
        return await this.client.post(`/conversation/${conversationId}/read`, {
            message: messageId,
        });
    }

    public async getOperator(
        integrationId: string,
        userId: string,
        avatarId: string
    ): Promise<Operator> {
        return await this.client.get(`/integration/${integrationId}/operator`, {
            user: userId,
            avatar: avatarId,
        });
    }

    public async getBehaviors(integrationId: string): Promise<Behavior[]> {
        return await this.client.get(`/integration/${integrationId}/behaviors`);
    }

    public async closeConversation(
        conversationId: string
    ): Promise<Conversation> {
        return await this.client.post(`/conversation/${conversationId}/close`);
    }
}
